import { captureBrowserError, startBrowserErrorMonitoring } from './lib/observability/bugsnag';

startBrowserErrorMonitoring();

void import('./bootstrap')
  .then(({ bootstrapApplication }) => bootstrapApplication())
  .catch((error: unknown) => {
    captureBrowserError(error, { observability: { phase: 'application-bootstrap' } });
  });
